import { createReducer, updateState } from "../handlers"
import types from "./types"
const initialState = {
  searchConvMassiveActions: false
}

const getOperatorPermission = (state, action) => {
  return updateState(state, action.payload)
}

export default createReducer(initialState, {
  [types.PERMISSIONS_SET_OPERATOR]: getOperatorPermission
})